import ApartmentTypeService from '../../services/ApartmentTypeService'
import BuildingService from '../../services/BuildingService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'

export const namespaced = true

const initialState = {
  apartmentTypes: [],
  selectedApartmentType: null
}

export const state = {
  apartmentTypes: [],
  selectedApartmentType: null
}

export const mutations = {
  SET_APARTMENT_TYPES(state, recs) {
    state.apartmentTypes = recs
  },
  SET_SELECTED_APARTMENT_TYPE(state, rec) {
    state.selectedApartmentType = rec
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchApartmentTypes: function(context, value) {
    return BuildingService.getApartmentTypesForBuilding(
      context.rootGetters['BuildingStore/getSelectedBuildingId']
    ).then(
      r => {
        context.commit('SET_APARTMENT_TYPES', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_APARTMENT_TYPES', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedApartmentType: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ApartmentTypeService.getApartmentTypeById(value).then(
      r => {
        context.commit('SET_SELECTED_APARTMENT_TYPE', r.data)
        context.dispatch(
          'BreadcrumbsStore/add',
          {
            text: 'APARTMENT TYPE ',
            name: r.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_APARTMENT_TYPE', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  addApartmentType: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    return ApartmentTypeService.addApartmentType(value)
  },
  updateApartmentType: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    return ApartmentTypeService.updateApartmentType(value).then(
      res => {
        context.commit('SET_SELECTED_APARTMENT_TYPE', res.data)
        context.dispatch(
          'BreadcrumbsStore/update',
          {
            text: 'APARTMENT TYPE ',
            name: res.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_APARTMENT_TYPE', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  deleteApartmentType: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      return await ApartmentTypeService.deleteApartmentType(value)
    } catch (error) {
      throw error
    }
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  getSelectedApartmentTypeId: state => {
    return state.selectedApartmentType ? state.selectedApartmentType.id : 0
  }
}
